<template>
  <div>
    <!--====== PRELOADER PART START ======-->
    <!--
    <div class="loader-wrap">
        <div class="preloader"><div class="preloader-close">Preloader Close</div></div>
        <div class="layer layer-one"><span class="overlay"></span></div>
        <div class="layer layer-two"><span class="overlay"></span></div>
        <div class="layer layer-three"><span class="overlay"></span></div>
    </div> -->

    <!--====== PRELOADER PART ENDS ======-->

    <!--====== OFFCANVAS MENU PART START ======-->
    <sidebar-home-one
      :sidebar="sidebar"
      @toggleSidebar="toggleSidebar"
      :menuItems="navs"
    />

    <!--====== OFFCANVAS MENU PART ENDS ======-->

    <!--====== HEADER PART START ======-->

    <header-home-eight @toggleSidebar="toggleSidebar" :menuItems="navs" />

    <!--====== HEADER PART ENDS ======-->

    <!--====== SECTION 1: HERO ======-->

    <hero-home-eight />

    <!--====== SECTION 2: 문제 제기 - 기존 외주의 한계 ======-->

    <services-home-eight />

    <!--====== SECTION 3: AI Studio는 무엇이 다른가 ======-->

    <services-home-two
        title="AI Studio는 개발팀의
일하는 방식을 바꿉니다"
        description="스윙투앱 팀이 AI를 활용해 대신 만들어주는 제작 서비스"
    />

    <!--====== SECTION 4: 제작 프로세스 ======-->

    <work-home-eight />

    <!--====== SECTION 5+6: 결과물 & 왜 AI Studio인가 ======-->

    <about-home-eight />

    <!--====== SECTION: 외주 vs AI Studio 비교 + 가격 플랜 ======-->

    <blog-home-eight />

    <!--====== SECTION 7: CTA ======-->

    <get-started-home-eight />

    <!--====== FOOTER ======-->

    <footer-home-one />

    <!--====== CONTACT POPUP ======-->
    <contact-popup :visible="showContactPopup" :selectedPlan="selectedPlan" @close="showContactPopup = false" />

    <!--====== BACK TO TOP ======-->
    <div class="back-to-top back-to-top-8">
      <a href="#"><i class="fal fa-arrow-up"></i></a>
    </div>
    <!--====== BACK TO TOP ENDS ======-->
  </div>
</template>

<script>
import SidebarHomeOne from "../HomeOne/SidebarHomeOne.vue";
import AboutHomeEight from "./AboutHomeEight.vue";
import GetStartedHomeEight from "./GetStartedHomeEight.vue";
import HeaderHomeEight from "./HeaderHomeEight.vue";
import HeroHomeEight from "./HeroHomeEight.vue";
import ServicesHomeEight from "./ServicesHomeEight.vue";
import BlogHomeEight from "./BlogHomeEight.vue";
import WorkHomeEight from "./WorkHomeEight.vue";
import ServicesHomeTwo from "@/components/HomeTwo/ServicesHomeTwo.vue";
import FooterHomeOne from "@/components/HomeOne/FooterHomeOne.vue";
import ContactPopup from "./ContactPopup.vue";

export default {
  components: {
    FooterHomeOne,
    ServicesHomeTwo,
    SidebarHomeOne,
    HeaderHomeEight,
    HeroHomeEight,
    AboutHomeEight,
    ServicesHomeEight,
    WorkHomeEight,
    GetStartedHomeEight,
    BlogHomeEight,
    ContactPopup,
  },
  data() {
    return {
      showContactPopup: false,
      selectedPlan: '',
      sidebar: false,
      navs: [
        {
          name: "home",
          path: "/",
        },
        {
          name: "서비스",
          childrens: [
            {
              name: "AI Studio 제작 서비스",
              path: "/landing/customization",
            },
            {
              name: "홈페이지로 앱제작",
              path: "/landing/webview",
            },
            {
              name: "템플릿으로 앱 제작",
              path: "/landing/prototype",
            },
            {
              name: "앱스토어 & 플레이스토어 유지보수",
              path: "/landing/storemt",
            }
          ]
        },
        {
          name: "상담신청",
          path: "#contact-popup",
        },
      ],
    };
  },
  mounted() {
    document.addEventListener("scroll", this.topToBottom);
    this.$root.$on('open-contact-popup', this.openContactPopup);
    document.addEventListener('click', this.interceptContactLink);
  },
  beforeDestroy() {
    this.$root.$off('open-contact-popup', this.openContactPopup);
    document.removeEventListener('click', this.interceptContactLink);
  },
  methods: {
    topToBottom() {
      const result = document.querySelector(".back-to-top");
      if (
        document.body.scrollTop > window.innerHeight ||
        document.documentElement.scrollTop > window.innerHeight
      ) {
        result.style.display = "block";
      } else {
        result.style.display = "none";
      }
    },
    openContactPopup(plan) {
      this.selectedPlan = plan || '';
      this.showContactPopup = true;
    },
    interceptContactLink(e) {
      const link = e.target.closest('a[href="#contact-popup"]');
      if (link) {
        e.preventDefault();
        this.showContactPopup = true;
      }
    },
    toggleSidebar() {
      this.sidebar = !this.sidebar;
    }
  },
};
</script>

<style>
/* No additional styles needed - popup styles removed */
</style>
